module.exports = __webpack_public_path__ + "assets/img/free_22.f11ef6e3.png";